// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1181":"4e8ebf95","2792":"6ce86127","4922":"cf672f77","5240":"2f0fad9b","8112":"6ce86127","9202":"3a5cdbd5"}[chunkId] + ".chunk.css";
};